import { render, staticRenderFns } from "./PublicAccessModal.vue?vue&type=template&id=63bfec02&scoped=true&"
import script from "./PublicAccessModal.vue?vue&type=script&lang=js&"
export * from "./PublicAccessModal.vue?vue&type=script&lang=js&"
import style0 from "./PublicAccessModal.vue?vue&type=style&index=0&id=63bfec02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bfec02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCheckbox,VTextField})
